export default "<router-outlet></router-outlet>\n<app-footer></app-footer>\n"